import { DefaultState, IState } from './state';
import { Keys, Types } from './actions/types';
import { ActivityReservation } from '../../../model/activities';


export const reducer = (state: IState = DefaultState(), action: Types): IState => {
    switch (action.type) {
        case (Keys.SAVENEWACTIVITY_FULFILLED): {
            let currIdx = state.allActivities.findIndex(a => a._id === action.payload.activityDefinition._id);
            const a = action.payload.activityDefinition;
            a.validFrom = new Date(a.validFrom);
            a.expiresOn = new Date(a.expiresOn);

            if (currIdx > -1)
                state.allActivities.splice(currIdx, 1, a);
            else
                state.allActivities.push(a)
            return {
                ...state,
                allActivities: [...state.allActivities]
            }
        }
        case (Keys.UPDATEACTIVITY): {
            return {
                ...state,
                activityDefinition: action.payload
            }
        }
        case (Keys.SELECTACTIVITY):
        case (Keys.SELECTACTIVITY_PENDING):
            {
                return {
                    ...state,
                    isLoadingDetails: true,
                }
            }
        case (Keys.SELECTACTIVITY_FULFILLED): {
            (action.payload.schedules || []).forEach(s => { s.date = new Date(s.date) });
            action.payload.activityDefinition.validFrom = new Date(action.payload.activityDefinition.validFrom);
            action.payload.activityDefinition.expiresOn = new Date(action.payload.activityDefinition.expiresOn)

            return {
                ...state,
                isLoadingDetails: false,
                activityDefinition: action.payload.activityDefinition,
                currentSchedules: action.payload.schedules
            }
        }
        case (Keys.SAVEACTIVITY):
        case (Keys.SAVEACTIVITY_PENDING):
            {
                return {
                    ...state,
                    isLoadingDetails: true,
                }
            }
        case (Keys.SAVEACTIVITY_FULFILLED):
            {
                (action.payload.schedules || []).forEach(s => { s.date = new Date(s.date) });
                action.payload.activityDefinition.validFrom = new Date(action.payload.activityDefinition.validFrom);
                action.payload.activityDefinition.expiresOn = new Date(action.payload.activityDefinition.expiresOn)
                const idx = state.allActivities.findIndex(a => a._id === action.payload.activityDefinition._id);
                if (idx > -1) {
                    state.allActivities.splice(idx, 1, action.payload.activityDefinition);
                }
                return {
                    ...state,
                    isLoadingDetails: false,
                    allActivities: [...state.allActivities],
                    activityDefinition: action.payload.activityDefinition,
                    currentSchedules: action.payload.schedules
                }
            }
        case (Keys.SAVEACTIVITY_REJECTED):
            {
                return {
                    ...state,
                    isLoadingDetails: false,
                }
            }
        case (Keys.SELECTACTIVITY_REJECTED): {
            return {
                ...state,
                isLoadingDetails: false,
                activityDefinition: undefined,
                currentSchedules: undefined
            }
        }
        case (Keys.LOADACTIVITIES_FULFILLED): {
            const activities = (action.payload || []).map(a => {
                return {
                    ...a,
                    validFrom: new Date(a.validFrom),
                    expiresOn: new Date(a.expiresOn)
                }
            })
            return {
                ...state,
                allActivities: activities,
                isLoading: false,
            }
        }
        case (Keys.LOADACTIVITIES_REJECTED): {
            return {
                ...state,
                isLoading: false
            }
        }
        case (Keys.LOADACTIVITIES): {
            return {
                ...state,
                isLoading: true
            }
        }
        case (Keys.LOADACTIVITIES_PENDING): {
            return {
                ...state,
                isLoading: true
            }
        }
        case Keys.DELETEACTIVITY_PENDING:
            {
                return {
                    ...state,
                    isLoading: true
                }
            }
        case Keys.DELETEACTIVITY_REJECTED:
            {
                return {
                    ...state,
                    isLoading: false
                }
            }
        case Keys.DELETEACTIVITY_FULFILLED: {
            const id = action.meta;
            const activities = state.allActivities;
            const idx = activities.findIndex(a => a._id === id);
            if (idx > -1)
                activities.splice(idx, 1);
            return {
                ...state,
                isLoading: false,
                allActivities: [...activities],
                activityDefinition: undefined
            }
        }
        case Keys.DELETESCHEDULE:
        case Keys.DELETESCHEDULE_PENDING:
        case Keys.CREATESCHEDULE:
        case Keys.CREATESCHEDULE_PENDING:
        case Keys.SAVESCHEDULE_PENDING:
        case Keys.SAVESCHEDULE: {
            return {
                ...state,
                isLoadingDetails: true,
                addedSchedule: undefined
            }
        }
        case Keys.DELETESCHEDULE_REJECTED:
        case Keys.CREATESCHEDULE_REJECTED:
        case Keys.SAVESCHEDULE_REJECTED: {
            return {
                ...state,
                isLoadingDetails: false
            }
        }
        case Keys.SAVESCHEDULE_FULFILLED: {
            const curr = [...state.currentSchedules];
            action.payload.date = new Date(action.payload.date);
            let idx = curr.findIndex(a => a._id === action.payload._id);
            if (idx > -1)
                curr.splice(idx, 1, action.payload);
            return {
                ...state,
                currentSchedules: curr,
                isLoadingDetails: false
            }
        }
        case Keys.CREATESCHEDULE_FULFILLED: {
            action.payload.date = new Date(action.payload.date);
            const curr = [...state.currentSchedules, action.payload];
            return {
                ...state,
                currentSchedules: curr,
                isLoadingDetails: false,
                addedSchedule: action.payload
            }
        }
        case Keys.DELETESCHEDULE_FULFILLED: {
            const curr = [...state.currentSchedules];
            let idx = curr.findIndex(a => a._id === action.meta);
            if (idx > -1)
                curr.splice(idx, 1);
            return {
                ...state,
                currentSchedules: curr,
                isLoadingDetails: false
            }
        }

        case Keys.DELETESCHEDULES:
        case Keys.DELETESCHEDULES_PENDING:
        case Keys.CREATESCHEDULES:
        case Keys.CREATESCHEDULES_PENDING: {
            return {
                ...state,
                isLoadingDetails: true,
            }
        }
        case Keys.DELETESCHEDULES_REJECTED:
        case Keys.CREATESCHEDULES_REJECTED: {
            return {
                ...state,
                isLoadingDetails: false
            }
        }
        case Keys.CREATESCHEDULES_FULFILLED: {
            action.payload.forEach(s => s.date = new Date(s.date));
            const curr = [...state.currentSchedules, ...action.payload];
            return {
                ...state,
                currentSchedules: curr,
                isLoadingDetails: false
            }
        }
        case Keys.DELETESCHEDULES_FULFILLED: {
            const curr = [...state.currentSchedules];
            (action.meta || []).forEach(id => {
                let idx = curr.findIndex(a => id === a._id);
                if (idx > -1)
                    curr.splice(idx, 1);
            });
            return {
                ...state,
                currentSchedules: curr,
                isLoadingDetails: false
            }
        }
        case Keys.REMOVERESERVATION:
        case Keys.REMOVERESERVATION_PENDING:
        case Keys.ADDRESERVATION:
        case Keys.ADDRESERVATION_PENDING:
            {
                return {
                    ...state,
                    isLoadingDetails: true
                }
            }
        case Keys.ADDRESERVATION_FULFILLED:
            {
                const r = action.payload as ActivityReservation;
                let s = state.currentSchedules.findIndex(a => a._id === r.activityScheduleId);
                if (s > -1)
                {
                    const resIdx =state.currentSchedules[s].reservations.findIndex(a=>a._id === r._id); 
                    if(resIdx === -1)
                        state.currentSchedules[s].reservations = [...state.currentSchedules[s].reservations,r];
                }
                return {
                    ...state,
                    currentSchedules: [...state.currentSchedules],
                    isLoadingDetails: false,
                }
            }
        case Keys.REMOVERESERVATION_FULFILLED:
            {
                const r = action.payload;
                //console.log("------------------------------------------r-e-m-o-v-e-1------------")
                //console.log(r)
                let s = state.currentSchedules.findIndex(a => a._id === r.activityScheduleId);
                if (s > -1)
                    state.currentSchedules[s].reservations.splice(s, 1);
                return {
                    ...state,
                    currentSchedules: [...state.currentSchedules],
                    isLoadingDetails: false
                }
            }
        case Keys.ADDRESERVATION_REJECTED:
        case Keys.REMOVERESERVATION_REJECTED:
            {
                return {
                    ...state,
                    isLoadingDetails: false
                }
            }
        default:
            return state;
    }
}